import moment from 'moment';

const dateUtils = {
  isInRange(strDate, dateRange) {
    const date = moment(strDate).toDate();

    const start = moment(dateRange.from).toDate();
    const end = moment(dateRange.to).toDate();

    // console.warn(`${dateRange.from} - ${dateRange.to} between ${start} - ${end}`);
    return date >= start && date <= end;
  },
};

export default dateUtils;
